import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";

// OPTIONAL: if you already created serviceWorkerRegistration.js earlier
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// ✅ Global PWA install prompt store
window.__TB_PWA_PROMPT__ = null;

// ✅ Capture beforeinstallprompt as early as possible
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__TB_PWA_PROMPT__ = e;

  // Notify any screen listening that prompt is available
  window.dispatchEvent(new Event("tb-pwa-prompt-available"));
  console.log("beforeinstallprompt captured globally");
});

window.addEventListener("appinstalled", () => {
  window.__TB_PWA_PROMPT__ = null;
  window.dispatchEvent(new Event("tb-pwa-installed"));
  console.log("appinstalled fired");
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// ✅ register SW only in production (as per serviceWorkerRegistration.js)
serviceWorkerRegistration.register();

reportWebVitals();
